import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import vuetify from "./plugins/vuetify"
import i18n from "./plugins/i18n"
import Rules from "./store/Commun/Rules.js"
import StoreUniversite from "./store/InscriptionUniversite/InscripionUniversiteStore.js"
import StoreSousMenu from "./store/SousMenuUm6p/SousMenuUm6pStore.js"
import "./plugins/vuetify-money.js"
import StoreContact from "./store/Contact/ContactStore.js"
import StoreResultatBac from "./store/InscriptionUniversite/ResultatBacStore.js"
import BourseStore from "./store/BourseEcoleCentrale/BourseStore.js"
Vue.config.productionTip = false

// Liste des rules de validation pour tout le site
Vue.prototype.$rules = Rules
Vue.prototype.$storeUniversite = StoreUniversite
Vue.prototype.$storeSousMenu = StoreSousMenu
Vue.prototype.$storeContact = StoreContact
Vue.prototype.$storeResultatBac = StoreResultatBac
Vue.prototype.$storeBourse = BourseStore
new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app")
